export const ADD_PROJECT = "ADD_PROJECT";
export const EDIT_PROJECT = "EDIT_PROJECT";
export const DELETE_PROJECT = "DELETE_PROJECT";
export const DEFINIR_PROJECTS = "DEFINIR_PROJECTS";

export const ADD_NOTIFICATION = "ADD_NOTIFICATION";

export const ADD_TASK = "ADD_TASK";
export const DEFINIR_TAKS = "DEFINIR_TAKS";
export const EDIT_TASK = "EDIT_TASK";
export const DELETE_TASK = "DELETE_TASK";
